import * as Sentry from "@sentry/react";

Sentry.init({
  enabled: import.meta.env.MODE === "production",
  dsn: import.meta.env.VITE_SENTRY_DSN,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.browserProfilingIntegration(),
  ],
  tracesSampleRate: 1.0,
  tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
  profilesSampleRate: 1.0,
  beforeSend(event: any, hint: any) {
    const error = hint.originalException;

    // Ignore specific error types.
    if (error && error instanceof Error) {
      if (error.message.includes("401")) {
        return null;
      }

      if (
        error.message.includes("Network Error") ||
        error instanceof TypeError
      ) {
        return null;
      }

      if (
        error.message.includes("Extension") ||
        error.message.includes("AdBlock")
      ) {
        return null;
      }
    }

    return event;
  },
});
